import React, { useRef } from 'react';

import styles from 'css_modules/DocumentsTableHeader.module.css';

import { ReactComponent as ChevronDownIcon } from 'assets/svg/chevron_down.svg';
import { ReactComponent as ChevronUpIcon } from 'assets/svg/chevron_up.svg';

export const DocumentsTableHeader = ({
    setOrdering,
    orderBy,
    ordering,
    children,
    selected,
    index,
    columnWidths,
    setColumnWidths,
    autoFitColumn,
    forceMinWidth
}) => {

    const startX = useRef(0);
    const startWidth = useRef(0);

    const ascend = () => setOrdering(orderBy);
    const descend = () => setOrdering(`-${orderBy}`);

    const removeOrdering = () => {
        setOrdering(' ');
        sessionStorage.setItem('ordering', null);
    };

    const startResize = (e) => {
        e.preventDefault();
        e.stopPropagation();

        startX.current = e.clientX;

        const current = parseInt(columnWidths[index], 10);
        startWidth.current = isNaN(current) ? 200 : current;

        const titleElement = e.currentTarget
            .parentElement
            .querySelector(`.${styles.titleBlock}`);

        const headerMin =
            Math.ceil(titleElement.scrollWidth) + 20;

        const minWidth = Math.max(
            headerMin,
            forceMinWidth || 0
        );

        const onMouseMove = (event) => {
            const diff = event.clientX - startX.current;

            const newWidth = Math.max(
                minWidth,
                startWidth.current + diff
            );

            const newWidths = [...columnWidths];
            newWidths[index] = `${newWidth}px`;

            setColumnWidths(newWidths);
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const handleDoubleClick = (e) => {
        if (!autoFitColumn) return;

        const titleElement = e.currentTarget
            .closest('th')
            .querySelector(`.${styles.titleBlock}`);

        const headerMin =
            Math.ceil(titleElement.scrollWidth) + 20;

        const minWidth = Math.max(
            headerMin,
            forceMinWidth || 0
        );

        const fittedWidth = autoFitColumn(index);

        const finalWidth =
            typeof fittedWidth === 'number'
                ? Math.max(fittedWidth, minWidth)
                : minWidth;

        const newWidths = [...columnWidths];
        newWidths[index] = `${finalWidth}px`;

        setColumnWidths(newWidths);
    };

    const isSelected = selected !== 0;

    return (
        <th
            className={styles.headerCell}
            onDoubleClick={handleDoubleClick}
        >
            <div className={styles.headerContent}>
                <div className={styles.titleBlock}>
                    <div className={
                        isSelected
                            ? styles.selectedtext
                            : styles.normaltext
                    }>
                        {children}
                    </div>

                    <div className={styles.sortIcons}>
                        <ChevronUpIcon
                            onClick={selected === -1 ? removeOrdering : ascend}
                            className={selected === -1 ? styles.selectedicon : styles.icon}
                        />
                        <ChevronDownIcon
                            onClick={selected === 1 ? removeOrdering : descend}
                            className={selected === 1 ? styles.selectedicon : styles.icon}
                        />
                    </div>
                </div>

                <div
                    className={styles.resizeHandle}
                    onMouseDown={startResize}
                />
            </div>
        </th>
    );
};